import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ContactoService {

  constructor(
      private _http: HttpClient,
      private router: Router
  ) { }

  /**
   * @description Enviar datos para contactar cliente
   * @param {Object[]} datosContacto - Lista de aerolíneas
   * @return {string} Respuesta de servicio llamame
   */
  envDataContacto(contacto){
    let urlBase = 'https://content.mundojoven.com/integrator-ws/savescheduledcontact';
    return this._http.post(urlBase, contacto);
  }

  /**
   * @description Regresa token
   * @param fecha actual
   * @return {string} Token
   */
  getToken() {
    const fecha = new Date().getTime();
    const url = `https://content.mundojoven.com/integrator-fuv/getchallenge?username=cmsuser&_=${fecha}`;
    return this._http.get(url)
      .map((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  }

  /**
   * @description Generar sessionname
   * @param token token compuesto
   * @return {string} sessionname
   */
  getSessionName(token){
    let url = `https://content.mundojoven.com/integrator-fuv/login?username=cmsuser&acceskey=${token}`;
    return this._http.post(url, '')
      .map((data) => {
        return data;
      })
      .catch((err) => {
        return err;
        this.router.navigate(['/m/vuelos/error-vuelos']);
      });
  }


}